// source: pbtypes/cloud/services/skygateway/iface_stats.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_byte_rate_pb = require('../../../../pbtypes/gen/flight_connect/byte_rate_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_byte_rate_pb);
goog.exportSymbol('proto.skygateway.AggregateInterfaceStats', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.AggregateInterfaceStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.AggregateInterfaceStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.AggregateInterfaceStats.displayName = 'proto.skygateway.AggregateInterfaceStats';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.AggregateInterfaceStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.AggregateInterfaceStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.AggregateInterfaceStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AggregateInterfaceStats.toObject = function(includeInstance, msg) {
  var f, obj = {
sampleCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
byteRate: (f = msg.getByteRate()) && pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.toObject(includeInstance, f),
forwardedByteRate: (f = msg.getForwardedByteRate()) && pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.toObject(includeInstance, f),
droppedBytes: (f = msg.getDroppedBytes()) && pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.toObject(includeInstance, f),
avgRttMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
minRttMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
maxRttMs: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.AggregateInterfaceStats}
 */
proto.skygateway.AggregateInterfaceStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.AggregateInterfaceStats;
  return proto.skygateway.AggregateInterfaceStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.AggregateInterfaceStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.AggregateInterfaceStats}
 */
proto.skygateway.AggregateInterfaceStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSampleCount(value);
      break;
    case 2:
      var value = new pbtypes_gen_flight_connect_byte_rate_pb.ByteRate;
      reader.readMessage(value,pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.deserializeBinaryFromReader);
      msg.setByteRate(value);
      break;
    case 3:
      var value = new pbtypes_gen_flight_connect_byte_rate_pb.ByteRate;
      reader.readMessage(value,pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.deserializeBinaryFromReader);
      msg.setForwardedByteRate(value);
      break;
    case 4:
      var value = new pbtypes_gen_flight_connect_byte_rate_pb.ByteRate;
      reader.readMessage(value,pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.deserializeBinaryFromReader);
      msg.setDroppedBytes(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAvgRttMs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMinRttMs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxRttMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.AggregateInterfaceStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.AggregateInterfaceStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.AggregateInterfaceStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AggregateInterfaceStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSampleCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getByteRate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.serializeBinaryToWriter
    );
  }
  f = message.getForwardedByteRate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.serializeBinaryToWriter
    );
  }
  f = message.getDroppedBytes();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_flight_connect_byte_rate_pb.ByteRate.serializeBinaryToWriter
    );
  }
  f = message.getAvgRttMs();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getMinRttMs();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getMaxRttMs();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional uint32 sample_count = 1;
 * @return {number}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getSampleCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.setSampleCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional flight_connect.ByteRate byte_rate = 2;
 * @return {?proto.flight_connect.ByteRate}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getByteRate = function() {
  return /** @type{?proto.flight_connect.ByteRate} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flight_connect_byte_rate_pb.ByteRate, 2));
};


/**
 * @param {?proto.flight_connect.ByteRate|undefined} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
*/
proto.skygateway.AggregateInterfaceStats.prototype.setByteRate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.clearByteRate = function() {
  return this.setByteRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.AggregateInterfaceStats.prototype.hasByteRate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional flight_connect.ByteRate forwarded_byte_rate = 3;
 * @return {?proto.flight_connect.ByteRate}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getForwardedByteRate = function() {
  return /** @type{?proto.flight_connect.ByteRate} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flight_connect_byte_rate_pb.ByteRate, 3));
};


/**
 * @param {?proto.flight_connect.ByteRate|undefined} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
*/
proto.skygateway.AggregateInterfaceStats.prototype.setForwardedByteRate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.clearForwardedByteRate = function() {
  return this.setForwardedByteRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.AggregateInterfaceStats.prototype.hasForwardedByteRate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional flight_connect.ByteRate dropped_bytes = 4;
 * @return {?proto.flight_connect.ByteRate}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getDroppedBytes = function() {
  return /** @type{?proto.flight_connect.ByteRate} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flight_connect_byte_rate_pb.ByteRate, 4));
};


/**
 * @param {?proto.flight_connect.ByteRate|undefined} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
*/
proto.skygateway.AggregateInterfaceStats.prototype.setDroppedBytes = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.clearDroppedBytes = function() {
  return this.setDroppedBytes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.AggregateInterfaceStats.prototype.hasDroppedBytes = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint32 avg_rtt_ms = 5;
 * @return {number}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getAvgRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.setAvgRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 min_rtt_ms = 6;
 * @return {number}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getMinRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.setMinRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 max_rtt_ms = 7;
 * @return {number}
 */
proto.skygateway.AggregateInterfaceStats.prototype.getMaxRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AggregateInterfaceStats} returns this
 */
proto.skygateway.AggregateInterfaceStats.prototype.setMaxRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.skygateway);
